import { render, staticRenderFns } from "./NomenclatorManager.vue?vue&type=template&id=afd4455e"
import script from "./NomenclatorManager.vue?vue&type=script&lang=js"
export * from "./NomenclatorManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports